import { render, staticRenderFns } from "./ImportWarehouse.vue?vue&type=template&id=96d8c7be&scoped=true"
import script from "./ImportWarehouse.vue?vue&type=script&lang=js"
export * from "./ImportWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d8c7be",
  null
  
)

export default component.exports